import styled from 'styled-components';
import { type ColumnElement } from './column-elements';

export const ColumnElementBase = styled.div.attrs<ColumnElement>(
  ({ $alignRows, $columnIndex, $rowIndex, $withElementClass = true }) => ({
    className: $withElementClass ? 'es-column-element' : undefined,
    style: $alignRows
      ? {
          // Используем inline-стили чтоб не приходилось создавать динамический класс под каждую ячейку таблицы
          gridArea: `${$rowIndex} / ${$columnIndex}`
        }
      : undefined
  })
)`
  z-index: 1;
`;
